import React from 'react';
import { Badge } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';


const EnabledBadge = ({enabled}) => {
  const { t } = useTranslation();
  if (enabled) {
    return (<Badge variant="success">{t('active')}</Badge>)
  } else {
    return (<Badge variant="danger">{t('inactive')}</Badge>)
  }
}

export default EnabledBadge
